import { autoinject } from 'aurelia-framework';
import { AssessmentContext } from 'app/ext/mcg-informed/assessment-context';
import { State } from 'app/shared/lib/state';
import * as Mcg from 'app/ext/mcg-informed/interfaces'

@autoinject
export class QuestionBase {

    ////****************** Fields and Properties ************************************////
    public question: Mcg.Question | null = null;
    protected questionNumberDisplay: string = "";
    protected readonly: boolean = false;
    public isValid: boolean = false;
    protected state: State = new State();
    public labelId: string | null = null;

    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(protected readonly context: AssessmentContext) { }

}
